import { Component, OnInit, ViewChild } from '@angular/core';
//import {Control} from '@angular/common';
import {  ProfileDataService, SeedDataService} from '../../Services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Compiler, NgZone } from '@angular/core';
//import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

import { LOVTypes, LOV } from '../../Models/seed.data';
import { Profile } from '../../Models/profile.model';
import { Page } from '../../Models/pages';
import {SelectItem, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, CalendarModule,Message, ConfirmationService} from 'primeng/primeng';
import { EditKeyTrackerComponent } from '../edit-key-tracker/edit-key-tracker.component';

@Component({
    //moduleId: module.id,
    templateUrl: './TeamMember.html'
})



export class TeamMemberComponent implements OnInit {

    @ViewChild(EditKeyTrackerComponent) editTeamMemberCodePopup: EditKeyTrackerComponent;

    ValidateTeammemebrCodeDuplicate : boolean;
    ValidMobileNumber: boolean;
    ValidDate: boolean;
    Isprocess: boolean;
    ValidEmailID: boolean;
    ValidPersonalEmailID: boolean;
    PageIsvalid: boolean;
    PageIsvalidPhone: boolean;
    PageIsvalidEmail: boolean;
    PageIsvalidPersonalEmail: boolean;
    displayDialog: boolean;
    shown: boolean;
    showntd: boolean;
    showncon: boolean;
    disabletd:boolean;
    disablebg:boolean;
    deletebg:boolean;
    disablecon:boolean;
    canceltripdisable:boolean;
    tripcount:string;

    shownbg: boolean;
    shownagree:boolean;
    useridstore: string;
    accomodationShown:boolean;
    ProbationEmploymentType: boolean;
    VisibleStatus: boolean = false;
    profile: PrimeProfile = new PrimeProfile();
    pages: Page[];
    selectedTeamMemberProfile: Profile;
    hdnLOVID: number;
    hdnID: string;
    hdnstausID: number;
    isNameTake: boolean;
    isEmailTake: boolean;
    isNewLov: boolean = true;
    teamMemberReportDump : any[];
    newProfile: boolean;
    IsErrorMessage: boolean;
    IsStatusCode: boolean;
    profiles: PrimeProfile[];
    contractual: any;
    pipeline: any;
    exit: any;
    active: any;
    resigned: any;
    msgs: Message[] = [];

    userform: FormGroup;

    submitted: boolean;

    Label: string;
    MandatoryStar: string;

    workLocation: SelectItem[];
    designation: SelectItem[];
    gender: SelectItem[];

    businessUnit: SelectItem[];
    lblType: string;
    maritalStatus: SelectItem[];
    employmentType: SelectItem[];
    hiringType: SelectItem[];
    contractType: SelectItem[];
    noticePeriodInstructions :SelectItem[];
    pFPreferenceAttheTimeOfExit:SelectItem[];
    status: SelectItem[];
    departmentID: SelectItem[];

    newDepartmentID : SelectItem[];
    clientID: SelectItem[];
    projectGroup : any;
    expertiseID: SelectItem[];
    tempExpertiseID: SelectItem[];
    primaryTechnology : any;
    secondaryTechnology: any;
    tertiaryTechnology: any;
    practiceID : SelectItem[];
    gradeID : SelectItem[];
    hrBusinessPartnerSelectedID : SelectItem[];
    companyID : SelectItem[];

    manager: SelectItem[];
    deliveryUnit: SelectItem[];
    systemRole: SelectItem[];
    lead: SelectItem[];
    functionalLead: SelectItem[];
    referralName: SelectItem[];
    dateOfBirth: string;
    HiddenForPipeline: any;
    employmentTypeStatus: boolean = false;
    IsDelete: boolean;
    IsSave: boolean;
    IsUserAdmin: boolean;
    homeLocation: SelectItem[];

    workPlanID: SelectItem[];
    TMWorkPlanAlreadyExist:any;
    TMWorkPlanDate:any;
    isworkPlanID:any;

	showEditTeamMemberCode : boolean = false; /*Added by Raveendra Sharma to make status code editable only by popup form*/
	public travelInfoDetails: any;
    public bgdetailInfo: any;
    public contractDetails:any;
	refdate: any;

    useridl:string
    isTravelDetail: boolean;
    travelType: SelectItem[];
    purpose: SelectItem[];
    isAgreement: boolean;
    travelStartDate: string;
    travelEndDate: string;
    travelCountryVisited: SelectItem[];
    travelCityVisited: string;
    travelClientVisited: string;
    travelAgreementduration: string;
    AgreementStartDate: string;
    AgreementEndDate: string;
    chequeNo: string;
    chequeAmount: string;
    uploadURLlink: string;
    countryVisitedName:string;
    isTDdelete: number=0;
    isTDAdded: number=0;


    isBGDetail: boolean;
    bgVerificationStatus: SelectItem[];
    bgStatusCode: SelectItem[];
    verificationDoneBy: SelectItem[];
    verificationCompletedOn: string;
    bgvCaseNo: string;
    bgReportURL: string;

     iscontractDetail:boolean;
    contractPurpose: SelectItem[];
    contractAmount: string;
    contractCheque: string;
    //contractType: SelectItem[];
    contractNote:string;

    experienceToDate: Date;
    dateValidation : boolean =  true;
    dateContractValidation:boolean=true;
    ValidWorkexpToDate:boolean = true;  

	displayAssignWorkPlanDialog: boolean;
    workPlanList : any[];
    workPlanHistoryID : number;
    resignationDate :string;
    confirmationDate : string;
    payrollLWD : string;
    probationPeriodId : SelectItem[];
    noticePeriodId : SelectItem[];
    visibleIfResigned: boolean = false;
    initialDOJ : string;
    visiblePayrollLWD: boolean = false;
    priorRelevantExperience: any;

    constructor(private route: ActivatedRoute, private router: Router,private profiledataservice: ProfileDataService, private seedDataService: SeedDataService, private fb: FormBuilder, private confirmationService: ConfirmationService, private _compiler: Compiler, private zone: NgZone) {
        // this.bindList();
        this.HiddenForPipeline = "";
        this._compiler.clearCache();
        this.ngOnInit();
        if (JSON.parse(window.localStorage.getItem('pagedetails')) != null) {
            this.pages = JSON.parse(window.localStorage.getItem('pagedetails'));
            if (router.url != '/home') {
                var isValid = false;
                for (var i = 0; i < this.pages.length; i++) {

                    if (this.pages[i].url == router.url) {


                        if (this.pages[i].permissionID == 1) {

                            this.IsDelete = false;
                            this.IsSave = false;
                        }
                        if (this.pages[i].permissionID == 2) {
                            this.IsDelete = false;
                            this.IsSave = true;
                        }
                        if (this.pages[i].permissionID == 3) {

                            this.IsDelete = true;
                            this.IsSave = true;
                        }

                    }


                }
            }

        }

    }

    ngOnInit() {
        this.ValidateTeammemebrCodeDuplicate=false;
        this.submitted = false;
        this.shown = false;
        this.showntd = false;
        this.showncon = false;
        this.disabletd = false;
        this.disablebg = false;
        this.deletebg = false;
        this.disablecon = false;
        this.useridstore="";
        this.tripcount="0";
        this.shownbg = false;
        this.TMWorkPlanAlreadyExist=false;
        this.TMWorkPlanDate=false;
        this.isworkPlanID=false;
        this.accomodationShown = false;
        this.PageIsvalid = true;
        this.PageIsvalidPhone = true;
        this.PageIsvalidEmail = true;
        this.PageIsvalidPersonalEmail = true;
        this.ValidMobileNumber = true;
        this.ValidEmailID = true;
        this.ValidPersonalEmailID = true;
        this.ValidDate = true;
        this.employmentTypeStatus = false;
        this.IsUserAdmin = (JSON.parse(window.localStorage.getItem('currentUser')).RoleName == "Admin");

        this.userform = this.fb.group({

            'teamMemberCode': ["", Validators.compose([Validators.required, this.validateName.bind(this)])],
            'status': ["", Validators.required],
            'firstName': ["", Validators.required],
            'lastName': ["", Validators.required],
            'email': ["", Validators.compose([Validators.required, this.validateEmail.bind(this)])],
            'mobile': ["", Validators.required],
            'dateOfBirth': ["", Validators.required],
            'maritalStatus': ["", Validators.required],
            'pan': [""],
            'workLocation': [""],
            'designation': ["", Validators.required],
            'dateofJoining': ["", Validators.required],
            'employmentType': ["", Validators.required],
            'systemRole': ["", Validators.required],
            'gender': ["", Validators.required],
            'businessUnit': ["", Validators.required],
            'remarks': [""],
            'oldTeamMemberCode': [""],
            'manager': ["", Validators.required],
            'deliveryUnit': ["", Validators.required],
            'lead': [""],
            'functionalLead': [""],
            'alternateEmailId': [""],
            'punchCardSerial': [""],
            'locker': [""],
            'nameInPanCard': [""],
            'earlierExitRemarks': [""],
            'lastWorkingDay': [""],
            // 'contractStartDate': [''],
            // 'contractEndDate': [''],
            'pfdoj': [""],
            'esicdoj': [''],
            'departmentID': ["", Validators.required],

            'newDepartmentID': [""],
            'clientID': [""],
            'projectGroup':[""],
            'tempExpertiseID':[""],
            'primaryTechnology' : [""],
            'secondaryTechnology': [""],
            'tertiaryTechnology': [""],
            'practiceID' : ["", Validators.required],
            'gradeID' : [""],

             'celebratedDateOfBirth': [""],
             'anniversaryDate': [""],
             'practiceQualification': [""],
             'delieveryQualification': [""],
             'annualCTC': [""],
             'ctcGroup': [""],
             'variable': [""] ,
             'homeLocation': [""],

			'workPlanID': [""],
            'isTravelDetail':[""],
             'isAgreement': [""],
             'travelType': ["",Validators.required],
             'purpose': ["",Validators.required],
             'travelStartDate': ["",Validators.required],
            'travelEndDate': ["",Validators.required],
            'travelCountryVisited': ["",Validators.required],
            'travelCityVisited': ["",Validators.required],
            'travelClientVisited': [""],
            'travelAgreementduration': [""],
            'AgreementStartDate': [""],
            'AgreementEndDate': [""],
            'chequeNo': [""],
            'chequeAmount': [""],
            'uploadURLlink': [""],
            'countryVisitedName':[""],

            'isBGDetail': [""],
             'bgVerificationStatus': ["",Validators.required],
             'bgStatusCode': [""],
            'verificationDoneBy': [""],
            'verificationCompletedOn': [""],
            'bgvCaseNo': [""],
            'bgReportURL': [""],

            'isContractDetail': [""],
            'contractPurpose': [""],
            'contractAmount': [""],
            'contractCheque': [""],
            'contractType': [""],
            'contractNote': [""],
            'hrBusinessPartnerSelectedID' : [""],
            'companyID' : [""],
            'resignationDate' : [""],
            'confirmationDate' : [""],
            'probationPeriodId' : [""],
            'payrollLWD' : [""],
            'noticePeriodId' : [""],
            'initialDOJ' : [""],
            'priorRelevantExperience' : ["",Validators.required]



        });
        this.seedDataService.GetKeyValue("Contractual").subscribe((data) => {
            this.contractual = data;
        });
        this.seedDataService.GetKeyValue("Pipeline").subscribe((data) => {
            this.pipeline = data;
        });
        this.seedDataService.GetKeyValue("Exit").subscribe((data) => {
            this.exit = data;
        });
        this.seedDataService.GetKeyValue("Active").subscribe((data) => {
            this.active = data;
        });
        this.seedDataService.GetKeyValue("Resigned").subscribe((data) => {
            this.resigned = data;
        });
        this.seedDataService.GetKeyValue("All").subscribe((data) => {
            this.resigned = data;
        });
        // this.profiledataservice.getTeamMemberReport().subscribe(res => {
            
        //     this.teamMemberReportDump = res;
           
        // });

        // Load team members list independently
        this.profiledataservice.GetTeamMembers(0).subscribe((data: any) => {
            this.profiles = data;
        });

        // Load all dropdowns independently so a slow/failing GetTeamMembers call doesn't block them
        this.seedDataService.getLOVByTypeName("Location").subscribe((yearslist: SelectItem[]) => {
            this.workLocation = this.renamePropertyNames(JSON.stringify(yearslist), "Select Location");
        });
        this.seedDataService.getLOVByTypeName("Designation").subscribe((list: SelectItem[]) => {
            this.designation = this.renamePropertyNames(JSON.stringify(list), "Select Designation");
        });
        this.seedDataService.getLOVByTypeName("Gender").subscribe((genderlist: SelectItem[]) => {
            this.gender = this.renamePropertyNames(JSON.stringify(genderlist), "Select Gender");
        });
        this.seedDataService.getLOVByTypeName("BusinessUnit").subscribe((currentProjectlist: SelectItem[]) => {
            this.businessUnit = this.renamePropertyNames(JSON.stringify(currentProjectlist), "Select Business Unit");
        });
        this.seedDataService.getLOVByTypeName("MaritalStatus").subscribe((maritalStatuslist: SelectItem[]) => {
            this.maritalStatus = this.renamePropertyNames(JSON.stringify(maritalStatuslist), "Select Marital Status");
        });
        this.seedDataService.getLOVByTypeName("EmploymentType").subscribe((employmentTypelist: SelectItem[]) => {
            this.employmentType = this.renamePropertyNames(JSON.stringify(employmentTypelist), "Select Employment Type");
        });
        this.seedDataService.getLOVByTypeName("HiringType").subscribe((HiringTypelist: SelectItem[]) => {
            this.hiringType = this.renamePropertyNames(JSON.stringify(HiringTypelist), "Select Hiring Type");
        });
        this.seedDataService.getLOVByTypeName("ContractType").subscribe((ContractTypelist: SelectItem[]) => {
            this.contractType = this.renamePropertyNames(JSON.stringify(ContractTypelist), "Select Contract Type");
        });
        this.seedDataService.getLOVByTypeName("NoticePeriodType").subscribe((NoticePeriodTypelist: SelectItem[]) => {
            this.noticePeriodInstructions = this.renamePropertyNames(JSON.stringify(NoticePeriodTypelist), "Select Notice Period Type");
        });
        this.seedDataService.getLOVByTypeName("PFPreferenceAtTheTimeOfExitType").subscribe((PFPreferenceAtTheTimeOfExitList: SelectItem[]) => {
            this.pFPreferenceAttheTimeOfExit = this.renamePropertyNames(JSON.stringify(PFPreferenceAtTheTimeOfExitList), "Select PF Preference Period Type");
        });
        this.seedDataService.getLOVByTypeName("Status").subscribe((statuslist: SelectItem[]) => {
            this.status = this.renamePropertyNames(JSON.stringify(statuslist), "Select Status");
        });
        this.seedDataService.getLOVByTypeName("Department").subscribe((departmentlist: SelectItem[]) => {
            this.departmentID = this.renamePropertyNames(JSON.stringify(departmentlist), "Select Department");
        });
        this.seedDataService.getLOVByTypeName("NewDepartment").subscribe((newDepartmentlist: SelectItem[]) => {
            this.newDepartmentID = this.renamePropertyNames(JSON.stringify(newDepartmentlist), "Select Department");
        });
        this.seedDataService.getLOVByTypeName("Grade").subscribe((gradeList: SelectItem[]) => {
            this.gradeID = this.renamePropertyNames(JSON.stringify(gradeList), "Select Grade");
        });
        this.seedDataService.getLOVByTypeName("WorkPlan").subscribe((newDepartmentlist: SelectItem[]) => {
            this.workPlanID = this.renamePropertyNames(JSON.stringify(newDepartmentlist), "Select Work Plan");
        });
        this.seedDataService.getLOVByTypeName("TravelType").subscribe((yearslist: SelectItem[]) => {
            this.travelType = this.renamePropertyNames(JSON.stringify(yearslist), "Select Travel");
        });
        this.seedDataService.getLOVByTypeName("TravelPurpose").subscribe((yearslist: SelectItem[]) => {
            this.purpose = this.renamePropertyNames(JSON.stringify(yearslist), "Select Purpose");
        });
        this.seedDataService.getLOVByTypeName("TravelCountryVisited").subscribe((yearslist: SelectItem[]) => {
            this.travelCountryVisited = this.renamePropertyNames(JSON.stringify(yearslist), "Select Country Visited");
        });
        this.seedDataService.getLOVByTypeName("BGVerificationStatus").subscribe((yearslist: SelectItem[]) => {
            this.bgVerificationStatus = this.renamePropertyNames(JSON.stringify(yearslist), "Select Verification Status");
        });
        this.seedDataService.getLOVByTypeName("BGStatusCode").subscribe((yearslist: SelectItem[]) => {
            this.bgStatusCode = this.renamePropertyNames(JSON.stringify(yearslist), "Select Status Code");
        });
        this.seedDataService.getLOVByTypeName("BGVerificationDoneBy").subscribe((yearslist: SelectItem[]) => {
            this.verificationDoneBy = this.renamePropertyNames(JSON.stringify(yearslist), "Select Verification Done By");
        });
        this.seedDataService.getLOVByTypeName("ContractPurpose").subscribe((yearslist: SelectItem[]) => {
            this.contractPurpose = this.renamePropertyNames(JSON.stringify(yearslist), "Select Contract Purpose");
        });
        this.seedDataService.getLOVByTypeName("Company").subscribe((companylist: SelectItem[]) => {
            this.companyID = this.renamePropertyNames(JSON.stringify(companylist), "Select Company");
        });
        this.seedDataService.getLOVByTypeName("NoticePeriod").subscribe((noticePeriodlist: SelectItem[]) => {
            this.noticePeriodId = this.renamePropertyNames(JSON.stringify(noticePeriodlist), "Select Notice Period");
        });
        this.seedDataService.getLOVByTypeName("ProbationPeriod").subscribe((probationPeriodlist: SelectItem[]) => {
            this.probationPeriodId = this.renamePropertyNames(JSON.stringify(probationPeriodlist), "Select Probation Period");
        });
        this.seedDataService.getHomeLocationLOV("Location").subscribe((yearslist: SelectItem[]) => {
            this.homeLocation = this.renamePropertyNames(JSON.stringify(yearslist), "Select Location");
        });

        /* Clients taking from Eagle portal */
        this.seedDataService.getClientsByDepartmentID(0).subscribe((clientList: SelectItem[]) => {
            this.clientID = this.renamePropertyNamesClient(JSON.stringify(clientList), "Select Client");
        });
        // Practices is used as Delivery Unit in Eagle portal
        this.seedDataService.getPracticesByDepartmentID(0).subscribe((practiceList: SelectItem[]) => {
            this.practiceID = this.renamePropertyNamesPractice(JSON.stringify(practiceList), "Select Delivery Unit");
        });

        this.profiledataservice.GetManagers().subscribe((managerlist: SelectItem[]) => {
            this.manager = this.renamePropertyNamesNew(JSON.stringify(managerlist), "Select Manager");
        });
        this.profiledataservice.GetRoles().subscribe((systemRoleslist: SelectItem[]) => {
            this.systemRole = this.renamePropertyNames(JSON.stringify(systemRoleslist), "Select System Role");
        });
        this.profiledataservice.GetTeamLeads().subscribe((leadlist: SelectItem[]) => {
            this.lead = this.renamePropertyNamesLead(JSON.stringify(leadlist), "Select Lead");
        });
        this.profiledataservice.GetTeamFunctionalLeads().subscribe((functionalLeadlist: SelectItem[]) => {
            this.functionalLead = this.renamePropertyNamesFunctionalLead(JSON.stringify(functionalLeadlist), "Select Functional Lead");
        });
        this.profiledataservice.GetTeamMembersName().subscribe((referralNameList: SelectItem[]) => {
            this.referralName = this.renamePropertyNamesReferrals(JSON.stringify(referralNameList), "Select Referral Name");
        });
        this.profiledataservice.GetHRBPTeamMembers().subscribe((hrbpslist: SelectItem[]) => {
            this.hrBusinessPartnerSelectedID = this.renamePropertyNamesHRs(JSON.stringify(hrbpslist), "Select HRBP");
        });

        this.onChangeNewDepartment(null);

    }

    onTeamMemberCodeChange($event){

       this.profile.teamMemberCode = $event.KeyValue;
    }

	checked(value: any) {

		var ele: any = document.getElementById('isOldTeamMember');
		if (ele.checked == true) {
            this.shown = true
		}
		else if (ele.checked == false)
            this.shown = false;
    }

    checkedAccomodation(value: any) {
		var ele: any = document.getElementById('isAccomodationArrangement');
		if (ele.checked == true) {
            this.accomodationShown = true
		}
		else if (ele.checked == false)
            this.accomodationShown = false;
    }

     checkedTravel(value: any) {
		var ele: any = document.getElementById('isTravelDetail');
		if (ele.checked == true) {
            this.showntd = true
		}
		else if (ele.checked == false)
            this.showntd = false;
    }
    checkedbg(value: any) {
		var ele: any = document.getElementById('isBGDetail');
		if (ele.checked == true) {
            this.shownbg = true;
		}
		else if (ele.checked == false)
            this.shownbg = false;
    }


    showDialogToAdd() {

        this.PageIsvalidPhone = true;
        this.PageIsvalidEmail = true;
        this.PageIsvalidPersonalEmail = true;
        this.ValidMobileNumber = true;
        this.ValidEmailID = true;
        this.ValidPersonalEmailID = true;
        this.ValidDate = true;
        this.employmentTypeStatus = false;
        this.isNewLov = true;
        this.shown = false;
        this.showntd = false;
        this.shownbg = false;
        this.TMWorkPlanAlreadyExist=false;
        this.TMWorkPlanDate=false;
        this.isworkPlanID=false;
        this.showncon = false;
        this.useridstore="";
        this.HiddenForPipeline = "HiddenForPipelineShow";
        this.MandatoryStar = "*"
       // this.useridstore=data.userID;
        this.Label = "Add New Team Member";
        //this.isNameTake = false;
        this.userform = this.fb.group(
            {
            'teamMemberCode': ["", Validators.compose([Validators.required, this.validateName.bind(this)])],
            'status': ["", Validators.required],

            'firstName': ["", Validators.required],
            'lastName': ["", Validators.required],
            'email': ["", Validators.compose([Validators.required, this.validateEmail.bind(this)])],
            'mobile': ["", Validators.required],
            'dateOfBirth': ["", Validators.required],
            'maritalStatus': ["", Validators.required],
            'pan': [""],
            'workLocation': [""],
            'designation': ["", Validators.required],
            'dateofJoining': ["", Validators.required],
            'employmentType': ["", Validators.required],
            'systemRole': ["", Validators.required],
            'gender': ["", Validators.required],
            'businessUnit': ["", Validators.required],
            'remarks': [""],
            'oldTeamMemberCode': [""],
            'manager': ["", Validators.required],
            'deliveryUnit': ["", Validators.required],
            'lead': [""],
            'functionalLead': [""],
            'alternateEmailId': [""],
            'punchCardSerial': [""],
            'locker': [""],
            'nameInPanCard': [""],
            'earlierExitRemarks': [""],
            'lastWorkingDay': [""],
            'pfdoj': [""],
            'esicdoj': [""],
            'departmentID': ["", Validators.required],

                'newDepartmentID': [""],
                'clientID': [""],
                'tempExpertiseID': [""],
                'projectGroup': [""],
                'primaryTechnology': [""],
                'secondaryTechnology': [""],
                'tertiaryTechnology': [""],
                'practiceID': [""],
                'gradeID' : [""],
                'hrBusinessPartnerSelectedID' : [""],
                'companyID' : [""],

            'celebratedDateOfBirth': [""],
            'anniversaryDate': [""],
            'practiceQualification': [""],
            'delieveryQualification': [""],
            'annualCTC': [""],
            'ctcGroup': [""],
            'variable': [""],


            'homeLocation': [""],

            'travelType': ["",Validators.required],
            'purpose': ["",Validators.required],
            'travelStartDate': ["",Validators.required],
            'travelEndDate': ["",Validators.required],
            'travelCountryVisited': ["",Validators.required],
            'travelCityVisited': ["",Validators.required],
            'travelClientVisited': [""],
            'travelAgreementduration': [""],
            'AgreementStartDate': [""],
            'AgreementEndDate': [""],
            'chequeNo': [""],
            'chequeAmount': [""],
            'uploadURLlink': [""],
            'countryVisitedName':[""],

            'bgVerificationStatus': ["",Validators.required],
            'bgStatusCode': [""],
            'resignationDate' : [""],
            'confirmationDate' : [""],
            'probationPeriodId' : [""],
            'payrollLWD' : [""],    
            'noticePeriodId' : [""],
            'initialDOJ' : [""],
            'priorRelevantExperience' : ["", Validators.required]
        });
        this.newProfile = true;
        this.profile = new PrimeProfile();
        this.displayDialog = true;
        this.hdnLOVID = 0;
        this.profiledataservice.GetTaravelInfo(0).subscribe(data => {

            this.travelInfoDetails = data;
            this.refdate = "?" + (new Date());
        });

        this.profiledataservice.GetContract(0).subscribe(data => {

            this.contractDetails = data;
            this.refdate = "?" + (new Date());
        });
        this.profiledataservice.GetBGDetail(0).subscribe(data => {

            this.bgdetailInfo = data;
            this.refdate = "?" + (new Date());
        });
    }
    close() {
      this.cancel();
    }
    showDialogEditTeamMemberCode() {
        this.showEditTeamMemberCode = !this.showEditTeamMemberCode;
        this.editTeamMemberCodePopup.teamMemberCodeValue=this.profile.teamMemberCode;
        if (this.showEditTeamMemberCode){

            this.editTeamMemberCodePopup.OnShow();
        }
    }

    onShowEditTeamMemberCodeChange($event) {

        this.showEditTeamMemberCode = $event;
    }

    bindList() {

        this.profiledataservice.GetTeamMembers(0).subscribe((lstprofiles) =>{
            this.profiles = lstprofiles;
        });
    }

    save() {

         if (this.newProfile) {
            this.profiles.push(this.profile);
            this.bindList();
        }
        else{
            this.profiles[this.findSelectedLeaveTypeIndex()] = this.profile;
            this.profile = null;
            this.displayDialog = false;
            this.bindList();
        }
         this.refresh();
    }

    CalculateTenure(){
         var today = new Date();
                var joiningdate = Date.parse(this.profile.dateofJoining)
                var diff_date =   Date.parse(today.toDateString()) - joiningdate;
                var num_years = diff_date/31536000000;
                var num_months = (diff_date % 31536000000)/2628000000;
                var num_days = ((diff_date % 31536000000) % 2628000000)/86400000;
                this.profile.tenureWithInfobeans = parseInt(num_years.toString(),10) +
                 ' Year ' + parseInt(num_months.toString(),10) +
                 ' Months '+ parseInt(num_days.toString(),10) + ' Days ';
    }


 CalculateWithTenure(travelSD:any,dependent :any, travelED: any){

      if (travelSD !=null && travelED !=null){
      var selectedToDateYear = new Date(travelED).getFullYear();
      var selectedstartYear = new Date(travelSD).getFullYear();
      this.experienceToDate= travelED;
      var experienceFromDate= travelSD;
      var expfromDate= dependent.fromDate;
      var exptoDate = dependent.toDate;
      var selectedID=  dependent.id;
      if(new Date(this.experienceToDate) < new Date(travelSD))
      {
          this.dateValidation=false;
          this.PageIsvalid = false
      }
      else{
          this.dateValidation=true;
this.PageIsvalid = true;
      }
      if(selectedToDateYear <= selectedstartYear){
          this.ValidWorkexpToDate = false;
         // this.PageIsvalid = false;
      }
      else {
          this.ValidWorkexpToDate = true;
          this.PageIsvalid = true;
}
}
       var today = new Date();
              var joiningdate = Date.parse(this.profile.dateofJoining)
              var diff_date =   Date.parse(today.toDateString()) - joiningdate;
              var num_years = diff_date/31536000000;
              var num_months = (diff_date % 31536000000)/2628000000;
              var num_days = ((diff_date % 31536000000) % 2628000000)/86400000;
              this.profile.tenureWithInfobeans = parseInt(num_years.toString(),10) +
               ' Year ' + parseInt(num_months.toString(),10) +
               ' Months '+ parseInt(num_days.toString(),10) + ' Days ';
  }
  CalculateContractWithTenure(travelSD:any,con :any, travelED: any){

      if (travelSD !=null && travelED !=null){
      var selectedToDateYear = new Date(travelED).getFullYear();
      var selectedstartYear = new Date(travelSD).getFullYear();
      this.experienceToDate= travelED;
      var experienceFromDate= travelSD;
      var expfromDate= con.fromDate;
      var exptoDate = con.toDate;
      var selectedID=  con.id;
      if(new Date(this.experienceToDate) < new Date(travelSD))
      {
          this.dateContractValidation=false;
           this.PageIsvalid = false;
      }
      else{
          this.dateContractValidation=true;
           this.PageIsvalid = true;
      }
      if(selectedToDateYear <= selectedstartYear){
          this.ValidWorkexpToDate = false;
         // this.PageIsvalid = false;
      }
      else {
          this.ValidWorkexpToDate = true;
          this.PageIsvalid = true;
}
}
       var today = new Date();
              var joiningdate = Date.parse(this.profile.dateofJoining)
              var diff_date =   Date.parse(today.toDateString()) - joiningdate;
              var num_years = diff_date/31536000000;
              var num_months = (diff_date % 31536000000)/2628000000;
              var num_days = ((diff_date % 31536000000) % 2628000000)/86400000;
              this.profile.tenureWithInfobeans = parseInt(num_years.toString(),10) +
               ' Year ' + parseInt(num_months.toString(),10) +
               ' Months '+ parseInt(num_days.toString(),10) + ' Days ';
  }

	renamePropertyNamesForDeliveryUnit(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("fullName")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["fullName"], 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }
    
    renamePropertyNamesHRs(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {
            
                if (obj[i].hasOwnProperty("hrBusinessPartner")) {
                        
                    objddl.push({
                        'label': obj[i]["hrBusinessPartner"] + " (" + obj[i]["teamMemberCode"] + ")"
                        , 'value': obj[i]["id"]
                    });
                }
                
            }
        }
        return objddl;
    }

	renamePropertyNames(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("name")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }
	renamePropertyNamesNew(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("manager")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["manager"] + " (" + obj[i]["teamMemberCode"] + ")", 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }

	renamePropertyNamesFunctionalLead(json: any, _firstOption: any) {
        var obj = JSON.parse(json);
        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("functionalLead")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["functionalLead"] + " (" + obj[i]["teamMemberCode"] + ")", 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }
	renamePropertyNamesLead(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("lead")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["lead"] + " (" + obj[i]["teamMemberCode"] + ")", 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }

    renamePropertyNamesClient(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("clientName")) {
                    objddl.push({ 'label': obj[i]["clientName"], 'value': obj[i]["clientID"] });
                }
            }
        }
        return objddl;
    }

    renamePropertyNamesPractice(json: any, _firstOption: any) {

        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("Name")) {
                    objddl.push({ 'label': obj[i]["Name"], 'value': obj[i]["practiceID"] });
                }
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["practiceID"] });
                }

            }
        }
        return objddl;
    }

     renamePropertyNamesExpertise(json: any, _firstOption: any) {

        if (json != null && json != '')
        {
            var obj = JSON.parse(json);
        }

         var objddl = [];
         objddl.push({ 'label': _firstOption, 'value': '' })

         if (obj != null && obj != undefined && obj != '') {
             for (var i = 0; i < obj.length; i++) {
                 if (obj[i].hasOwnProperty("expertiseName")) {
                     objddl.push({ 'label': obj[i]["expertiseName"], 'value': obj[i]["expertiseID"] });
                 }
             }
         }
         return objddl;
     }

    renamePropertyNamesReferrals(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                // if (obj[i].hasOwnProperty("referralNames")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["firstName"] + " "+ obj[i]["lastName"] + " (" + obj[i]["teamMemberCode"] + ")", 'value': obj[i]["UserID"] });
                // }
            }
        }
        return objddl;
    }
    //--------- Added By Shweta ---------------------
    AllowOnlyNumbers(event)
 {
    var k;
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   //!(keyCode >= 48 && keyCode <= 57)
   return((k >= 48 && k <= 57));
 }
 accept_alphabets(event){
        var k;
        k = event.charCode;
        return((k > 64 && k < 91) || (k > 96 && k < 123));
    }
    checkedtd(){

 var ele: any = document.getElementById('isTravelDetail');
 if (ele.checked == true) {
            this.showntd = true
		}
		else if (ele.checked == false)
        {
  this.showntd = false;
        }

    }
     checkedAgree(){
        var ele: any = document.getElementById('isAgr');
        if (ele.checked == true) {
            this.shownagree = true
		}
		else if (ele.checked == false)
        {
            this.shownagree = false;
        }
    }

    checkedcontract(){
        var ele: any = document.getElementById('iscontract');
        if (ele.checked == true) {
            this.showncon = true;

		}
		else if (ele.checked == false)
        {
            this.showncon = false;


        }
    }

    AddNewTravelInfo() {

        var role = JSON.parse(window.localStorage.getItem('currentUser'));
        this.canceltripdisable=false;
        this.profiledataservice.GetNewTravelInfo(this.useridstore).subscribe(data => {
        this.travelInfoDetails.splice(0,0, data);
        var s= this.travelInfoDetails.length;
        this.refdate = "?" + (new Date());
        this.zone.run(() => { });
        });
    }

    RemoveTrip(data: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this trip?',
            accept: () => {
                data.active = false;
                this.dateValidation = true;
                this.zone.run(() => { });
            }
        });
    }
    RemoveBGV(data: any) {

        this.confirmationService.confirm({
            message: 'Are you sure, you want to delete this background detail?',
            accept: () => {
                data.active = false;
                this.zone.run(() => { });
                // if (this.bgdetailInfo.length!=1 && this.bgdetailInfo.length>=2 ){
                //     this.bgdetailInfo.length=(this.bgdetailInfo.length-1);
                // }
                this.deletebg=true;
            }
        });
    }

    RemoveContract(data: any) {
//alert("row"+ row)

        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this contract?',
            accept: () => {
                data.active = false;
                this.dateContractValidation=true;

                    this.isTDdelete = this.isTDAdded - 1;

                // if(this.isTDdelete!=0)
                // {
                //     this.isTDdelete=this.isTDdelete-1;
                // }
                this.zone.run(() => { });
            }
        });

        alert("Deleted:" + this.isTDdelete)
    }

    AddNewBGDetail() {
this.deletebg=false;
            var role = JSON.parse(window.localStorage.getItem('currentUser'));
        this.canceltripdisable=false;
        this.profiledataservice.GetNewBGDetail(this.useridstore).subscribe(data => {
            this.bgdetailInfo.splice(0,0, data);
            this.refdate = "?" + (new Date());
            this.zone.run(() => { });
        });
    }

    AddNewContract() {


        var role = JSON.parse(window.localStorage.getItem('currentUser'));
        this.canceltripdisable=false;
        this.profiledataservice.GetNewContract(this.useridstore).subscribe(data => {
            this.contractDetails.splice(0,0, data);
            this.refdate = "?" + (new Date());
            this.zone.run(() => { });
        });

            this.isTDAdded=(this.isTDAdded + 1)

        alert("Added "+ this.isTDAdded)

    }

     //--------- End Added By Shweta ---------------------
    RemoveDependent(data: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                data.active = false;
                this.zone.run(() => { });
            }
        });
    }
	delete(event: any, data: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                this.profile = this.cloneLeaveType(data);
                this.profile.active = false;
                this.profiledataservice.SaveProfile(this.profile).subscribe((data) => {

                    this.ngOnInit();
                    this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member Deleted successfully !' });
                });
            }
        });
    }

    refresh() {
        window.location.reload();
    }

    OnDateSelect() {
        var currentDate = new Date();
        var selectedstartMinutes = new Date(this.profile.dateOfBirth).getMinutes();
        var selectedstartHours = new Date(this.profile.dateOfBirth).getHours();
        var selectedstartDate = new Date(this.profile.dateOfBirth).getDate();
        var selectedstartMonth = new Date(this.profile.dateOfBirth).getMonth();
        var selectedstartYear = new Date(this.profile.dateOfBirth).getFullYear();

        var newSelectedDate = new Date(selectedstartYear, selectedstartMonth, selectedstartDate, selectedstartHours, selectedstartMinutes);
        var dateAdded = newSelectedDate.setDate(newSelectedDate.getDate() + 5114);
        if (selectedstartDate) {

            if (newSelectedDate >= currentDate) {
                this.ValidDate = false;
                this.PageIsvalid = false;
            }
            else {
                this.ValidDate = true;
                this.PageIsvalid = true;
            }
        }
    }

    onChangeNewDepartment(event) {
        if (this.profile.newDepartmentID) {
            this.seedDataService.getExpertiseList(this.profile.newDepartmentID).subscribe((expertiseList: SelectItem[]) => {
                let data = this.renamePropertyNamesExpertise(JSON.stringify(expertiseList), "Select Expertise");
                this.expertiseID = data;
                this.profile.tempExpertiseID = this.profile.expertiseID;
            });
        }
        else {
            let data = this.renamePropertyNamesExpertise('', "Select Expertise");
            this.expertiseID = data;
        }
    }

    EmploymentTypeChange() {
        this.seedDataService.GetKeyValue("Contractual").subscribe((data) => {
            this.contractual = data;
        });
        var employmentTypeLabel = this.contractual;
        var employmentType = this.profile.employmentType;
        var selectedemploymentType = this.employmentType.filter(function (elem) {
            return elem.value == employmentType;
        });
        var index, len;
        for (index = 0, len = selectedemploymentType.length; index < len; ++index) {
            if (selectedemploymentType[index].label == this.contractual) {
                this.employmentTypeStatus = true;
            }
            else {
                this.employmentTypeStatus = false;
                this.profile.contractStartDate = null;
                this.profile.contractEndDate = null;
            }
        }

    }

HiringTypeChange() {
        var hiringType = this.profile.hiringType;
        var selectedemploymentType = this.hiringType.filter(function (elem) {
            return elem.value == hiringType;
        });
    }


PFPreferenceAtTheTimeOfExitTypeChange() {
        var pFPreferenceAttheTimeOfExit = this.profile.pFPreferenceAttheTimeOfExit;
        var selectedemploymentType = this.pFPreferenceAttheTimeOfExit.filter(function (elem) {
            return elem.value == pFPreferenceAttheTimeOfExit;
        });
    }

ContractTypeChange() {
        var contractType = this.profile.contractType;
        var selectedemploymentType = this.contractType.filter(function (elem) {
            return elem.value == contractType;
        });
    }
NoticePeriodTypeChange() {
        var noticePeriodInstructions = this.profile.noticePeriodInstructions;
        var selectedemploymentType = this.noticePeriodInstructions.filter(function (elem) {
            return elem.value == noticePeriodInstructions;
        });
    }

    ReferralNameChange() {
        var referralName = this.profile.referralName;
        var selectedReferralName = this.referralName.filter(function (elem) {
            return elem.value == referralName;
        });
    }

	onRowSelect(event: any, data: any) {
        console.log(data)
        this.MandatoryStar="*"
        this.shown = false;
        this.showntd = false;
        this.disabletd = false;
        this.disablebg = false;
        this.deletebg = false;
        this.disablecon = false;
        this.canceltripdisable = false;
        this.shownbg = false;
        this.TMWorkPlanAlreadyExist=false;
        this.TMWorkPlanDate=false;
        this.isworkPlanID=false;
        this.useridstore=data.userID;

        this.hdnLOVID = data['id'];
        if (data.contractStartDate == null || data.contractStartDate == '') {
            data.contractStartDate = new Date();
        }
        if (data.contractEndDate == null || data.contractEndDate == '') {
            data.contractEndDate = new Date();
        }
        if(data.isTravelDetail==true)
        {
            this.showntd=true;
            this.disabletd=true;
            this.canceltripdisable=true;

        }else{
             this.showntd=false;
            this.disabletd=false;
            this.canceltripdisable=false;

        }
        if(data.isBGDetail==true)
        {
                this.shownbg=true;
                this.disablebg=true;
        }else{
            this.shownbg=false;
                this.disablebg=false;

        }
        if(data.isContractDetail==true)
        {
                this.showncon=true;
                this.disablecon=true;

        }else{
            this.showncon=false;
              this.disablecon=false;

        }
        this.Label = "Edit Team Member";

        var status = data['status'];
        var teamMemberCode = data['teamMemberCode'];
        var email = data['email'];
        this.seedDataService.GetKeyValue("Pipeline").subscribe((data) => {
            this.pipeline = data;
        });
        this.seedDataService.GetKeyValue("Exit").subscribe((data) => {
            this.exit = data;
        });
        this.seedDataService.GetKeyValue("Resigned").subscribe((data) => {
            this.resigned = data;
        });

          this.profiledataservice.GetTaravelInfo(data.userID).subscribe(data => {

            this.travelInfoDetails = data;
            this.refdate = "?" + (new Date());
        });
        this.profiledataservice.GetContract(data.userID).subscribe(data => {

            this.contractDetails = data;
            this.refdate = "?" + (new Date());
        });

        this.profiledataservice.GetBGDetail(data.userID).subscribe(data => {

            this.bgdetailInfo = data;
            this.refdate = "?" + (new Date());
        });

        var selectedStatus = this.status.filter(function (elem) {
            return elem.value == status;
        });
        var index, len;
        for (index = 0, len = selectedStatus.length; index < len; ++index) {
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
                this.visiblePayrollLWD = true;
            }
            else {
                this.visiblePayrollLWD = false;
            }
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
                this.visibleIfResigned = true;
            }
            else {
                this.visibleIfResigned = false;
            }
        }
        for (index = 0, len = selectedStatus.length; index < len; ++index) {
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned) {
                this.VisibleStatus = true;
            }
            else {
                this.VisibleStatus = false;
            }
        }
        this.seedDataService.GetKeyValue("Contractual").subscribe((data) => {
            this.contractual = data;
        });
        var employmentTypeLabel = this.contractual;
        var employmentType = data['employmentType'];
        var selectedemploymentType = this.employmentType.filter(function (elem) {
            return elem.value == employmentType;
        });
        var index, len;
        for (index = 0, len = selectedemploymentType.length; index < len; ++index) {
            if (selectedemploymentType[index].label == this.contractual) {
                this.employmentTypeStatus = true;
            }
            else {
                this.employmentTypeStatus = false;
            }
        }

        this.newProfile = false;

        this.profile = this.cloneLeaveType(data);

        this.profile.tempExpertiseID = this.profile.expertiseID;

        this.onChangeNewDepartment(null);

        this.profile.active = true;

        this.displayDialog = true;
        for (index = 0, len = selectedStatus.length; index < len; ++index) {

            if (selectedStatus[index].label == this.pipeline) {
                this.MandatoryStar = "";
                this.HiddenForPipeline = "HiddenForPipeline";

                this.profile.teamMemberCode = ' ';
                this.profile.email = ' ';
                //document.getElementById('HiddenForPipeline').style.display = 'none';

            }
            else {
                this.HiddenForPipeline = "HiddenForPipelineShow";
            }
          }
        }
    assignWorkPlan(event: any, data: any){

        var teamMemberCode = data['teamMemberCode'];
        this.profile.teamMemberCode = data['teamMemberCode'];
        this.profile.firstName = data['firstName'];
        this.profile.lastName = data['lastName'];
        this.Label = 'Add / Edit Work Plan';
        this.displayAssignWorkPlanDialog = true;

        this.profiledataservice.GetWorkPlanByUserID(teamMemberCode).subscribe((data: any) => {
            this.workPlanList = data;

        })

    }
    onRowSelectWorkPlan(event: any, data: any) {

        this.MandatoryStar="*"
        this.shown = false;
        this.workPlanHistoryID = data['WorkPlanHistoryID'];
        if (data.contractStartDate == null || data.contractStartDate == '') {
            data.contractStartDate = new Date();
        }
        if (data.contractEndDate == null || data.contractEndDate == '') {
            data.contractEndDate = new Date();
        }
        this.Label = "Add / Edit Work Plan";

        var status = data['status'];
        var teamMemberCode = data['teamMemberCode'];
        var email = data['email'];
        this.seedDataService.GetKeyValue("Pipeline").subscribe((data) => {
            this.pipeline = data;
        });
        this.seedDataService.GetKeyValue("Exit").subscribe((data) => {
            this.exit = data;
        });
        this.seedDataService.GetKeyValue("Resigned").subscribe((data) => {
            this.resigned = data;
        });

        var selectedStatus = this.status.filter(function (elem) {
            return elem.value == status;
        });
        var index, len;
        for (index = 0, len = selectedStatus.length; index < len; ++index) {
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
                this.visiblePayrollLWD = true;
            }
            else {
                this.visiblePayrollLWD = false;
            }
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
                this.visibleIfResigned = true;
            }
            else {
                this.visibleIfResigned = false;
            }
        }
        for (index = 0, len = selectedStatus.length; index < len; ++index) {
            if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned) {
                this.VisibleStatus = true;
            }
            else {
                this.VisibleStatus = false;
            }
        }
        this.seedDataService.GetKeyValue("Contractual").subscribe((data) => {
            this.contractual = data;
        });
        var employmentTypeLabel = this.contractual;
        var employmentType = data['employmentType'];
        var selectedemploymentType = this.employmentType.filter(function (elem) {
            return elem.value == employmentType;
        });
        var index, len;
        for (index = 0, len = selectedemploymentType.length; index < len; ++index) {
            if (selectedemploymentType[index].label == this.contractual) {
                this.employmentTypeStatus = true;
            }
            else {
                this.employmentTypeStatus = false;
            }
        }
        this.newProfile = false;

        this.profile = this.cloneLeaveType(data);


        this.profile.tempExpertiseID = this.profile.expertiseID;

        this.onChangeNewDepartment(null);

        this.profile.active = true;

        this.displayAssignWorkPlanDialog = true;
        // for (index = 0, len = selectedStatus.length; index < len; ++index) {
        //     if (selectedStatus[index].label == this.pipeline) {
        //         this.MandatoryStar = "";
        //         this.HiddenForPipeline = "HiddenForPipeline";

        //         this.profile.teamMemberCode = ' ';
        //         this.profile.email = ' ';
        //         //document.getElementById('HiddenForPipeline').style.display = 'none';

        //     }
        //     else {
        //         this.HiddenForPipeline = "HiddenForPipelineShow";
        //     }

        // }

    }

    cloneLeaveType(c: PrimeProfile): PrimeProfile {
        let profile = new PrimeProfile();
        for (let prop in c) {
            profile[prop] = c[prop];
        }
        profile.initialDOJ = this.normalizeCalendarDate(profile.initialDOJ);
        return profile;

    }

    normalizeCalendarDate(value: any): any {
        if (value === undefined || value === null || value === '') {
            return value;
        }

        if (typeof value === 'string') {
            var dotNetMatch = /\/Date\((\d+)\)\//.exec(value);
            if (dotNetMatch && dotNetMatch[1]) {
                var dotNetDate = new Date(parseInt(dotNetMatch[1], 10));
                return isNaN(dotNetDate.getTime()) ? null : this.convert(dotNetDate.toString());
            }
        }

        var parsedDate = new Date(value);
        if (isNaN(parsedDate.getTime())) {
            return null;
        }

        return this.convert(parsedDate.toString());
    }

    findSelectedLeaveTypeIndex(): number {
        return this.profiles.indexOf(this.selectedTeamMemberProfile);
    }
    cancel() {
        this.displayDialog = false;
        var x = new PrimeProfile();
		this.profile = this.cloneLeaveType(x);
		var ele: any = document.getElementById('isOldTeamMember');
		ele.checked = false;
        this.IsErrorMessage = false;
        //var ele1: any = document.getElementById('isAccomodationArrangement');
        //ele1.checked = false;
        location.reload(true);
    }
    omit_special_char(event)
    {
       var k;
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }
    ValidPhone() {
        var PHONE_REGEXP = /^(\+[\d]{1,5}|0)?[6-9]\d{9}$/i;
        if (this.profile.mobile.toString().length < 10 || !PHONE_REGEXP.test(this.profile.mobile)) {
            this.ValidMobileNumber = false;
            this.PageIsvalidPhone = false;


        } else {
            this.ValidMobileNumber = true;
            this.PageIsvalidPhone = true;
        }

    }
    ValidEmail() {
        debugger;
        var EMAIL_REGEXP = /^([a-zA-Z0-9])+([a-zA-Z0-9\-_\.])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i;
        if (!(EMAIL_REGEXP.test(this.profile.email.toString()) && this.profile.email.toString().includes("infobeans.com"))) {
            this.ValidEmailID = false;
            this.PageIsvalidEmail = false;

        } else {
            this.ValidEmailID = true;
            this.PageIsvalidEmail = true;
        }


    }
    ValidPersonalEmail() {
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        if (!EMAIL_REGEXP.test(this.profile.alternateEmailId.toString()) && this.profile.alternateEmailId.toString() != "") {
            this.ValidPersonalEmailID = false;
            this.PageIsvalidPersonalEmail = false;

        } else {
            this.ValidPersonalEmailID = true;
            this.PageIsvalidPersonalEmail = true;
        }

    }
	emailValidator(control: any) {
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        if (!EMAIL_REGEXP.test(control.value)) {
            return { invalidEmail: true };
        }
    }

    validateName(control: FormControl) {

        if (control.value) {
            if (this.validateInputName(control.value)) {
//this.ValidateTeammemebrCodeDuplicate=true;
                return { "TeamMemberAlreadyExist": true };

            }
           // this.ValidateTeammemebrCodeDuplicate=false;
            return null;
        }
    }
    validateEmail(control: FormControl) {

        if (control.value) {
            if (this.validateInputEmail(control.value)) {
                return { "EmailAlreadyExist": true };
            }
            return null;
        }
    }
    //For Status Change Exit and Resigned
    StatusChange() {
        //this.seedDataService.GetKeyValue("Pipeline").subscribe((data) => {
        //    this.pipeline = data;
        //});
        //this.seedDataService.GetKeyValue("Exit").subscribe((data) => {
        //    this.exit = data;
        //});
        //this.seedDataService.GetKeyValue("Resigned").subscribe((data) => {
        //    this.resigned = data;
        //});
        var status = this.profile.status;
        var selectedStatus = this.status.filter(function (elem) {
            return elem.value == status;
        });
       var index, len;
       for (index = 0, len = selectedStatus.length; index < len; ++index) {
           if (selectedStatus[index].label == this.exit) {

               this.profile.isLoggedIn = '0';
           }
           if (selectedStatus[index].label == this.active)
           {

               this.profile.isLoggedIn = 'true';
           }

           if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
               this.visiblePayrollLWD = true;
           }
           else {
               this.visiblePayrollLWD = false;
               this.profile.payrollLWD = null;
           }
           if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned || selectedStatus[index].label == 'Exit' || selectedStatus[index].label == 'Resigned') {
               this.visibleIfResigned = true;
           }
           else {
               this.visibleIfResigned = false;
               this.profile.resignationDate = null;
           }
           if (selectedStatus[index].label == this.exit || selectedStatus[index].label == this.resigned) {
               this.VisibleStatus = true;
           }
           else {
               this.VisibleStatus = false;
               this.profile.lastWorkingDay = null;
           }
       }
       for (index = 0, len = selectedStatus.length; index < len; ++index) {
           if (selectedStatus[index].label == this.pipeline) {

               this.MandatoryStar = "";
               this.HiddenForPipeline = "HiddenForPipeline";
              // document.getElementById('HiddenForPipeline').style.display = 'none';
               this.profile.teamMemberCode = ' ';
               this.profile.email = ' ';



           }
           else {
               this.HiddenForPipeline = "HiddenForPipelineShow";
               if (this.profile.teamMemberCode == ' ') {
                   this.profile.teamMemberCode = '';
               }
               if (this.profile.email == ' ') {
                   this.profile.email = '';
               }
               this.MandatoryStar = "*";
             //  document.getElementById('HiddenForPipeline').style.display = 'block';


           }
       }

    }


	 public validateInputName(teamMemberCode: any) {
        this.isNameTake = false;
        var obj = this.profiles;
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("teamMemberCode")) {
                if (obj[i]["teamMemberCode"] != 0 && obj[i]["teamMemberCode"] != null) {
                    if (this.hdnLOVID > 0) {
                        if (obj[i]["teamMemberCode"] == teamMemberCode && obj[i]["id"] != this.hdnLOVID) {
                            this.isNameTake = true;

                            return this.isNameTake;
                        }

                    }
                    else {
                        if (obj[i]["teamMemberCode"] == teamMemberCode) {
                            this.isNameTake = true;
                            return this.isNameTake;

                        }
                    }
                }
            }
        }


    }
	validateInputEmail(email: any) {
        debugger;
        email= email.toLowerCase();
        this.isEmailTake = false;
        var obj = this.profiles;
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("email")) {
                if (obj[i]["email"] != "" && obj[i]["email"] != null) {
                    if (this.hdnLOVID > 0) {
                        if (obj[i]["email"] == email && obj[i]["id"] != this.hdnLOVID) {
                            this.isEmailTake = true;

                            return this.isEmailTake;
                        }

                    }
                    else {
                        if (obj[i]["email"] == email) {
                            this.isEmailTake = true;
                            return this.isEmailTake;

                        }
                    }
                }
            }
        }


    }
	createDateAsUTC(date: any) {

        var currDate = new Date(date);

        return currDate;
    }
	convert(str: any) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [mnth, day, date.getFullYear()].join("/");
    }
    //CheckValidations() {
    //    this.ValidEmail();
    //    this.ValidPhone();
    //    this.ValidPersonalEmail();

    //}


    onSubmit(value: string) {
       debugger;

        this.submitted = true;

        if(this.contractDetails!=undefined && this.contractDetails.length>0 )
        {
        for (var i = 0; i < this.contractDetails.length; i++) {

       if((new Date(this.contractDetails[i].contractEndDate)) < (new Date(this.contractDetails[i].contractStartDate)))
           {
                this.PageIsvalid = false;
                this.dateContractValidation = false;

            }
        }
    }
    if(this.travelInfoDetails!=undefined && this.travelInfoDetails.length>0  )
    {
    for (var i = 0; i < this.travelInfoDetails.length; i++) {
        if(this.travelInfoDetails[i].active)
        {
           if((new Date(this.travelInfoDetails[i].travelEndDate)) < (new Date(this.travelInfoDetails[i].travelStartDate)))

        {
            this.PageIsvalid = false;
            this.dateValidation = false;

        }


        if(this.travelInfoDetails[i].agreementStartDate!=null && this.travelInfoDetails[i].agreementEndDate!=null && (new Date(this.travelInfoDetails[i].agreementEndDate)) < (new Date(this.travelInfoDetails[i].agreementStartDate)))
        {
        {
          this.PageIsvalid = false;
          this.dateValidation = false;
        }
    }
    }
    }
}

// if(this.ValidateTeammemebrCodeDuplicate)
// {

//     this.PageIsvalid=false;
// }
// else
// {
//     this.PageIsvalid=true;
// }

        this.IsErrorMessage=false;
        if (this.PageIsvalid && this.PageIsvalidPersonalEmail && this.PageIsvalidEmail && this.PageIsvalidPhone) {

            //this.bindList();
            if (this.profile.dateofJoining != undefined && this.profile.dateofJoining != "") {
                this.profile.dateofJoining = this.createDateAsUTC(this.profile.dateofJoining).toString();
                this.profile.dateofJoining = this.convert(this.profile.dateofJoining)
            }
            if (this.profile.contractStartDate != undefined && this.profile.contractStartDate != "") {
                this.profile.contractStartDate = this.createDateAsUTC(this.profile.contractStartDate).toString();
                this.profile.contractStartDate = this.convert(this.profile.contractStartDate);
            }
            if (this.profile.contractEndDate != undefined && this.profile.contractEndDate != "") {
                this.profile.contractEndDate = this.createDateAsUTC(this.profile.contractEndDate).toString();
                this.profile.contractEndDate = this.convert(this.profile.contractEndDate);
            }
            if (this.profile.lastWorkingDay != undefined && this.profile.lastWorkingDay != "") {
                this.profile.lastWorkingDay = this.createDateAsUTC(this.profile.lastWorkingDay).toString();
                this.profile.lastWorkingDay = this.convert(this.profile.lastWorkingDay);
            }
            if (this.profile.pfdoj != undefined && this.profile.pfdoj != "") {
                this.profile.pfdoj = this.createDateAsUTC(this.profile.pfdoj).toString();
                this.profile.pfdoj = this.convert(this.profile.pfdoj);
            }
            if (this.profile.esicdoj != undefined && this.profile.esicdoj != "") {
                this.profile.esicdoj = this.createDateAsUTC(this.profile.esicdoj).toString();
                this.profile.esicdoj = this.convert(this.profile.esicdoj);
            }
            if (this.profile.dateOfBirth != undefined && this.profile.dateOfBirth != "") {
                this.profile.dateOfBirth = this.createDateAsUTC(this.profile.dateOfBirth).toString();
                this.profile.dateOfBirth = this.convert(this.profile.dateOfBirth);
            }
            if (this.profile.celebratedDateOfBirth != undefined && this.profile.celebratedDateOfBirth != "") {
                this.profile.celebratedDateOfBirth = this.createDateAsUTC(this.profile.celebratedDateOfBirth).toString();
                this.profile.celebratedDateOfBirth = this.convert(this.profile.celebratedDateOfBirth);
            }
            if (this.profile.anniversaryDate != undefined && this.profile.anniversaryDate != "") {
                this.profile.anniversaryDate = this.createDateAsUTC(this.profile.anniversaryDate).toString();
                this.profile.anniversaryDate = this.convert(this.profile.anniversaryDate);
            }
            if (this.profile.relocationExpensesPaymentDueDate != undefined && this.profile.relocationExpensesPaymentDueDate != "") {
                this.profile.relocationExpensesPaymentDueDate = this.createDateAsUTC(this.profile.relocationExpensesPaymentDueDate).toString();
                this.profile.relocationExpensesPaymentDueDate = this.convert(this.profile.relocationExpensesPaymentDueDate);
            }
             if (this.profile.joiningBonusPaymentDueDate != undefined && this.profile.joiningBonusPaymentDueDate != "") {
                this.profile.joiningBonusPaymentDueDate = this.createDateAsUTC(this.profile.joiningBonusPaymentDueDate).toString();
                this.profile.joiningBonusPaymentDueDate = this.convert(this.profile.joiningBonusPaymentDueDate);
            }
            if (this.profile.noticePeriodBuyoutPaymentDueDate != undefined && this.profile.noticePeriodBuyoutPaymentDueDate != "") {
                this.profile.noticePeriodBuyoutPaymentDueDate = this.createDateAsUTC(this.profile.noticePeriodBuyoutPaymentDueDate).toString();
                this.profile.noticePeriodBuyoutPaymentDueDate = this.convert(this.profile.noticePeriodBuyoutPaymentDueDate);
            }
            if (this.profile.annualBonusPaymentDueDate != undefined && this.profile.annualBonusPaymentDueDate != "") {
                this.profile.annualBonusPaymentDueDate = this.createDateAsUTC(this.profile.annualBonusPaymentDueDate).toString();
                this.profile.annualBonusPaymentDueDate = this.convert(this.profile.annualBonusPaymentDueDate);
            }
            if (this.profile.retentionBonusPaymentDueDate != undefined && this.profile.retentionBonusPaymentDueDate != "") {
                this.profile.retentionBonusPaymentDueDate = this.createDateAsUTC(this.profile.retentionBonusPaymentDueDate).toString();
                this.profile.retentionBonusPaymentDueDate = this.convert(this.profile.retentionBonusPaymentDueDate);
            }
            if (this.profile.otherBonusPaymentDueDate != undefined && this.profile.otherBonusPaymentDueDate != "") {
                this.profile.otherBonusPaymentDueDate = this.createDateAsUTC(this.profile.otherBonusPaymentDueDate).toString();
                this.profile.otherBonusPaymentDueDate = this.convert(this.profile.otherBonusPaymentDueDate);
            }
            if (this.profile.lWDInPreviousOrganization != undefined && this.profile.lWDInPreviousOrganization != "") {
                this.profile.lWDInPreviousOrganization = this.createDateAsUTC(this.profile.lWDInPreviousOrganization).toString();
                this.profile.lWDInPreviousOrganization = this.convert(this.profile.lWDInPreviousOrganization);
            }
             if (this.profile.accomodationFromDate != undefined && this.profile.accomodationFromDate != "") {
                this.profile.accomodationFromDate = this.createDateAsUTC(this.profile.accomodationFromDate).toString();
                this.profile.accomodationFromDate = this.convert(this.profile.accomodationFromDate);
            }
             if (this.profile.accomodationToDate != undefined && this.profile.accomodationToDate != "") {
                this.profile.accomodationToDate = this.createDateAsUTC(this.profile.accomodationToDate).toString();
                this.profile.accomodationToDate = this.convert(this.profile.accomodationToDate);
            }
            if (this.profile.resignationDate != undefined && this.profile.resignationDate != "") {
                this.profile.resignationDate = this.createDateAsUTC(this.profile.resignationDate).toString();
                this.profile.resignationDate = this.convert(this.profile.resignationDate);
            }

            if (this.profile.payrollLWD != undefined && this.profile.payrollLWD != "") {
                this.profile.payrollLWD = this.createDateAsUTC(this.profile.payrollLWD).toString();
                this.profile.payrollLWD = this.convert(this.profile.payrollLWD);
            }

            if (this.profile.confirmationDate != undefined && this.profile.confirmationDate != "") {
                this.profile.confirmationDate = this.createDateAsUTC(this.profile.confirmationDate).toString();
                this.profile.confirmationDate = this.convert(this.profile.confirmationDate);
            }
            
            if (this.profile.initialDOJ != undefined && this.profile.initialDOJ != "") {
                this.profile.initialDOJ = this.createDateAsUTC(this.profile.initialDOJ).toString();
                this.profile.initialDOJ = this.convert(this.profile.initialDOJ);
            } else {
                
                this.profile.initialDOJ = null;
            }
           
// ------- Added By Shweta ---------
 if (this.profile.travelStartDate != undefined && this.profile.travelStartDate != "") {
                this.profile.travelStartDate = this.createDateAsUTC(this.profile.travelStartDate).toString();
                this.profile.travelStartDate = this.convert(this.profile.travelStartDate);
            }
             if (this.profile.travelEndDate != undefined && this.profile.travelEndDate != "") {
                this.profile.travelEndDate = this.createDateAsUTC(this.profile.travelEndDate).toString();
                this.profile.travelEndDate = this.convert(this.profile.travelEndDate);
            }
             if (this.profile.AgreementStartDate != undefined && this.profile.AgreementStartDate != "") {
                this.profile.AgreementStartDate = this.createDateAsUTC(this.profile.AgreementStartDate).toString();
                this.profile.AgreementStartDate = this.convert(this.profile.AgreementStartDate);
            }
             if (this.profile.AgreementEndDate != undefined && this.profile.AgreementEndDate != "") {
                this.profile.AgreementEndDate = this.createDateAsUTC(this.profile.AgreementEndDate).toString();
                this.profile.AgreementEndDate = this.convert(this.profile.AgreementEndDate);
            }
               if (this.profile.verificationCompletedOn != undefined && this.profile.verificationCompletedOn != "") {
                this.profile.verificationCompletedOn = this.createDateAsUTC(this.profile.verificationCompletedOn).toString();
                this.profile.verificationCompletedOn = this.convert(this.profile.verificationCompletedOn);
            }

                if(this.travelInfoDetails != undefined  && this.profile.isTravelDetail==true)
                {

                    for (var i = 0; i < this.travelInfoDetails.length; i++) {
                        if(this.travelInfoDetails[i].active)
                        {
                          if(this.travelInfoDetails[i].travelType == null || this.travelInfoDetails[i].travelType == undefined || this.travelInfoDetails[i].travelType == ""
                || this.travelInfoDetails[i].purpose == null || this.travelInfoDetails[i].purpose == undefined || this.travelInfoDetails[i].purpose == ""
                || this.travelInfoDetails[i].travelStartDate == null || this.travelInfoDetails[i].travelStartDate == undefined || this.travelInfoDetails[i].travelStartDate == ""
                || this.travelInfoDetails[i].travelEndDate == null || this.travelInfoDetails[i].travelEndDate == undefined || this.travelInfoDetails[i].travelEndDate == ""
                || this.travelInfoDetails[i].travelCountryVisited == null || this.travelInfoDetails[i].travelCountryVisited == undefined || this.travelInfoDetails[i].travelCountryVisited == ""
                || this.travelInfoDetails[i].travelCityVisited == null || this.travelInfoDetails[i].travelCityVisited == undefined || this.travelInfoDetails[i].travelCityVisited == ""

                    )
                        {
                        this.IsErrorMessage = true;
                        }
                    }
                }
                }
                //please don't remove it.
                // else{
                //     if(!this.IsErrorMessage)
                //      {
                //           this.IsErrorMessage = false;
                //      }

                // }
                 if(this.bgdetailInfo != undefined &&  this.profile.isBGDetail==true)
                {
                    for (var i = 0; i < this.bgdetailInfo.length; i++) {

                        if(this.bgdetailInfo[i].active)
                        {
                    if(this.bgdetailInfo[i].bgVerificationStatus == null || this.bgdetailInfo[i].bgVerificationStatus == undefined || this.bgdetailInfo[i].bgVerificationStatus == ""
                    ||this.bgdetailInfo[i].verificationDoneBy == null || this.bgdetailInfo[i].verificationDoneBy == undefined || this.bgdetailInfo[i].verificationDoneBy == "" )
                    {
                        this.IsErrorMessage = true;
                    }
                    else
                    {
                         if(this.bgdetailInfo[i].bgVerificationStatus==this.bgVerificationStatus[3].value)
                        {
                             if(this.bgdetailInfo[i].bgStatusCode == null || this.bgdetailInfo[i].bgStatusCode == undefined || this.bgdetailInfo[i].bgStatusCode == "0" || this.bgdetailInfo[i].bgStatusCode == "")
                            {
                                this.IsErrorMessage = true;
                                this.IsStatusCode = true;
                            }
                        }
                    }
                }
                    }

                }
                else{
                    if(!this.IsErrorMessage)
                     {
                        this.IsErrorMessage = false;
                     }
                }

            if(this.profile.teamMemberCode == null || this.profile.teamMemberCode == undefined || this.profile.teamMemberCode == "" || this.validateInputName(this.profile.teamMemberCode)
             || this.profile.email == null || this.profile.email == undefined || this.profile.email == "" || this.validateInputEmail(this.profile.email)
             || this.profile.firstName == null || this.profile.firstName == undefined || this.profile.firstName == ""
             || this.profile.lastName == null || this.profile.lastName == undefined || this.profile.lastName == ""
             || this.profile.dateofJoining == null || this.profile.dateofJoining == undefined || this.profile.dateofJoining == ""
             || this.profile.employmentType == null || this.profile.employmentType == undefined || this.profile.employmentType == ""
             || this.profile.status == null || this.profile.status == undefined || this.profile.status == ""
             || this.profile.departmentID == null || this.profile.departmentID == undefined || this.profile.departmentID == ""
             || this.profile.workLocation == null || this.profile.workLocation == undefined || this.profile.workLocation == ""
             || this.profile.businessUnit == null || this.profile.businessUnit == undefined || this.profile.businessUnit == ""
             || this.profile.designation == null || this.profile.designation == undefined || this.profile.designation == ""
             || this.profile.systemRole == null || this.profile.systemRole == undefined || this.profile.systemRole == ""
             || this.profile.manager == null || this.profile.manager == undefined || this.profile.manager == ""
            //  || this.profile.deliveryUnit == null || this.profile.deliveryUnit == undefined || this.profile.deliveryUnit == ""
            || this.profile.practiceID == null || this.profile.practiceID == undefined || this.profile.practiceID == ""
             || this.profile.gender == null || this.profile.gender == undefined || this.profile.gender == ""
             || this.profile.dateOfBirth == null || this.profile.dateOfBirth == undefined || this.profile.dateOfBirth == ""
             || this.profile.maritalStatus == null || this.profile.maritalStatus == undefined || this.profile.maritalStatus == ""
             || this.profile.mobile == null || this.profile.mobile == undefined || this.profile.mobile == ""
             || this.profile.homeLocation == null || this.profile.homeLocation == undefined || this.profile.homeLocation == ""
             || this.profile.priorRelevantExperience == null || this.profile.priorRelevantExperience == undefined || this.profile.priorRelevantExperience == "" || this.profile.priorRelevantExperience.toString().trim() == ""

            ){
                this.IsErrorMessage = true;

            }
            else{
                if(!this.IsErrorMessage)
                {
                     this.IsErrorMessage = false;
                }

            }

            if(!this.IsErrorMessage)
            {

                this.profile.expertiseID = this.profile.tempExpertiseID;

                if (this.newProfile) {

                    this.profiledataservice.SaveProfile(this.profile).subscribe((data) => {
                        this.ngOnInit();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member saved successfully !' });
                    });

                    this.profiles.push(this.profile);
                }
                else {

console.log(this.profile);
                    this.profiledataservice.SaveProfile(this.profile).subscribe((data) => {

                        this.ngOnInit();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member updated successfully !' });
                    });
                    this.profiles[this.findSelectedLeaveTypeIndex()] = this.profile;

                }
                // -------- Added by shweta --- Save Travel Information
                if(  this.travelInfoDetails != undefined &&   this.profile.isTravelDetail==true){

                    for (var i = 0; i < this.travelInfoDetails.length; i++) {
                        this.travelInfoDetails[i].userID = this.useridstore;//995;
                        //this.travelInfoDetails[i].dependentDateOfBirth = this.createDateAsUTC(this.travelInfoDetails[i].dependentDateOfBirth);
            if (this.travelInfoDetails[i].travelStartDate != undefined && this.travelInfoDetails[i].travelStartDate != "") {
                this.travelInfoDetails[i].travelStartDate = this.createDateAsUTC(this.travelInfoDetails[i].travelStartDate).toString();
                this.travelInfoDetails[i].travelStartDate = this.convert(this.travelInfoDetails[i].travelStartDate);
            }
             if (this.travelInfoDetails[i].travelEndDate != undefined && this.travelInfoDetails[i].travelEndDate != "") {
                this.travelInfoDetails[i].travelEndDate = this.createDateAsUTC(this.travelInfoDetails[i].travelEndDate).toString();
                this.travelInfoDetails[i].travelEndDate = this.convert(this.travelInfoDetails[i].travelEndDate);
            }
             if (this.travelInfoDetails[i].AgreementStartDate != undefined && this.travelInfoDetails[i].AgreementStartDate != "") {
                this.travelInfoDetails[i].AgreementStartDate = this.createDateAsUTC(this.travelInfoDetails[i].AgreementStartDate).toString();
                this.travelInfoDetails[i].AgreementStartDate = this.convert(this.travelInfoDetails[i].AgreementStartDate);
            }
             if (this.travelInfoDetails[i].AgreementEndDate != undefined && this.travelInfoDetails[i].AgreementEndDate != "") {
                this.travelInfoDetails[i].AgreementEndDate = this.createDateAsUTC(this.travelInfoDetails[i].AgreementEndDate).toString();
                this.travelInfoDetails[i].AgreementEndDate = this.convert(this.travelInfoDetails[i].AgreementEndDate);
            }
               if (this.travelInfoDetails[i].verificationCompletedOn != undefined && this.travelInfoDetails[i].verificationCompletedOn != "") {
                this.travelInfoDetails[i].verificationCompletedOn = this.createDateAsUTC(this.travelInfoDetails[i].verificationCompletedOn).toString();
                this.travelInfoDetails[i].verificationCompletedOn = this.convert(this.travelInfoDetails[i].verificationCompletedOn);
            }
                    }
                    this.profiledataservice.SaveTravelInfo(this.travelInfoDetails).subscribe(data => {
                         this.ngOnInit();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member updated successfully !' });
                    });
                }
            //--- Save Background Verification

        if(this.bgdetailInfo != undefined && this.profile.isBGDetail==true)
                {

                    // if(this.bgdetailInfo.length==2)
                    // {
                    //     this.bgdetailInfo.length = this.bgdetailInfo.length-1;
                    // }
                    for (var i = 0; i < this.bgdetailInfo.length; i++) {
                        this.bgdetailInfo[i].userID = this.useridstore;//995;
                        if (this.bgdetailInfo[i].verificationCompletedOn != undefined && this.bgdetailInfo[i].verificationCompletedOn != "") {
                this.bgdetailInfo[i].verificationCompletedOn = this.createDateAsUTC(this.bgdetailInfo[i].verificationCompletedOn).toString();
                this.bgdetailInfo[i].verificationCompletedOn = this.convert(this.bgdetailInfo[i].verificationCompletedOn);
            }
                    }
                     this.profiledataservice.SaveBGDetail(this.bgdetailInfo).subscribe(data => {
                         this.ngOnInit();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member updated successfully !' });
                    });
                }
                //--- Save Miscellaneous contracts
                if(this.contractDetails !=undefined && this.contractDetails.length>0)
                {
        for (var i = 0; i < this.contractDetails.length; i++) {

            if (this.contractDetails[i].contractStartDate != undefined && this.contractDetails[i].contractStartDate != "") {
                        this.contractDetails[i].contractStartDate = this.createDateAsUTC(this.contractDetails[i].contractStartDate).toString();
                        this.contractDetails[i].contractStartDate = this.convert(this.contractDetails[i].contractStartDate);
                    }
                    if (this.contractDetails[i].contractEndDate != undefined && this.contractDetails[i].contractEndDate != "") {
                        this.contractDetails[i].contractEndDate = this.createDateAsUTC(this.contractDetails[i].contractEndDate).toString();
                        this.contractDetails[i].contractEndDate = this.convert(this.contractDetails[i].contractEndDate);
                    }

                }

            this.profiledataservice.SaveContract(this.contractDetails).subscribe(data => {
                                    this.ngOnInit();
                                    this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Team Member updated successfully !' });
                                });

                }
                this.profile = null;
                this.displayDialog = false;

                this.submitted = true;
                this.msgs = [];
                this.bindList();
                setTimeout(function(){location.reload();},500);

            }
        }
    }
    //------------Start Added by Sorabh------------//
    public IsDateRangeMatch : any[];
    checkWorkPlanAlreadyExist(data: any){
        debugger
        // this.IsDateRangeMatch = this.workPlanList.filter(t=>t.workPlanStartDate.indexOf(data.workPlanStartDate) && t.workPlanEndDate.indexOf(data.workPlanEndDate));
        if (data.workPlanID == null ||data.workPlanID =="")
        {
        this.isworkPlanID=true;
        this.PageIsvalid=false;
        }
        else{
        this.isworkPlanID=false;
        this.PageIsvalid=true;
        }

        if (data.workPlanStartDate != undefined || data.workPlanEndDate != undefined) {
            this.TMWorkPlanDate=false;

            //data.workPlanStartDate = this.createDateAsUTC(this.profile.workPlanStartDate).toString();
            //data.workPlanEndDate = this.createDateAsUTC(this.profile.workPlanEndDate).toString();
            // this.IsDateRangeMatch =  this.workPlanList.filter((item, index) => item.workPlanStartDate == data.workPlanStartDate && item.workPlanEndDate == data.workPlanEndDate && item.workPlanName && data.workPlanName);
            this.IsDateRangeMatch = this.workPlanList.filter((item, index) =>
                this.createDateAsUTC(item.workPlanStartDate).toString() == data.workPlanStartDate
                || this.createDateAsUTC(item.workPlanEndDate).toString() == data.workPlanEndDate);

            if (this.IsDateRangeMatch.length == 0) {
                this.IsDateRangeMatch = this.workPlanList.filter((item, index) =>
                    (this.createDateAsUTC(item.workPlanStartDate).toString() >= data.workPlanStartDate)
                    || (this.createDateAsUTC(item.workPlanEndDate).toString() <= data.workPlanEndDate));
            }
                if(this.IsDateRangeMatch.length > 0){
                   // return true;
                   this.TMWorkPlanAlreadyExist=true;
                     this.PageIsvalid=false;

                } else{
                    this.TMWorkPlanAlreadyExist=false;
                    this.PageIsvalid=true;
                   // return false;
                }
        }else{
            this.TMWorkPlanDate=false;
           // this.isworkPlanID=true;
            this.PageIsvalid=true;
            return false;
        }
    }


    addWorkPlan(value: string) {
        debugger
        var isWorkPlanExist = this.checkWorkPlanAlreadyExist(this.profile);
        // if(isWorkPlanExist){
        //     //alert('Work Plan type and date range is already exist.')
        //    return this.TMWorkPlanAlreadyExist=true;
        // }


        if (this.PageIsvalid && this.PageIsvalidPersonalEmail && this.PageIsvalidEmail && !isWorkPlanExist ) {

            if (this.profile.workPlanStartDate != undefined && this.profile.workPlanStartDate != "") {
                this.profile.workPlanStartDate = this.createDateAsUTC(this.profile.workPlanStartDate).toString();
                this.profile.workPlanStartDate = this.convert(this.profile.workPlanStartDate);
            }
            if (this.profile.workPlanEndDate != undefined && this.profile.workPlanEndDate != "") {
                this.profile.workPlanEndDate = this.createDateAsUTC(this.profile.workPlanEndDate).toString();
                this.profile.workPlanEndDate = this.convert(this.profile.workPlanEndDate);
            }






            this.profile.expertiseID = this.profile.tempExpertiseID;

            this.workPlanHistoryID = 0;
            this.profiledataservice.SaveWorkPlan(this.profile).subscribe((data) => {
                this.workPlanList =  data;

                this.ngOnInit();
                this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Work Plan Added Successfully !' });
            });


                this.profiles[this.findSelectedLeaveTypeIndex()] = this.profile;

            this.displayAssignWorkPlanDialog = true;
            // this.profile = null;
            // this.displayDialog = false;
            this.submitted = true;
            this.msgs = [];
            this.bindList();
            // location.reload();

        }
    }
    validateDecimal(event: any) {
        const inputValue = event.target.value;
        const reg = /^[0-9]*\.?[0-9]*$/;  
        if (!reg.test(inputValue)) {
           
            event.target.value = inputValue.slice(0, -1); 
        }
    }

    isValueMissing(value: any) {
        return value == null || value == undefined || value.toString().trim() == "";
    }

    shouldShowRequiredError(controlName: string, modelValue: any) {
        if (this.submitted) {
            return this.isValueMissing(modelValue);
        }

        if (!this.userform || !this.userform.controls || !this.userform.controls[controlName]) {
            return false;
        }

        return this.userform.controls[controlName].invalid
            && (this.userform.controls[controlName].dirty || this.userform.controls[controlName].touched);
    }

    isPriorRelevantExperienceMissing() {
        return this.profile.priorRelevantExperience == null
            || this.profile.priorRelevantExperience == undefined
            || this.profile.priorRelevantExperience.toString().trim() == "";
    }

    //------------End Added by Sorabh--------------//

    generateReportForTeamMember() {
  this.profiledataservice.getTeamMemberReport().subscribe(res => {
    this.teamMemberReportDump = res;
    
    // Generate CSV after data is loaded
    this.exportToCSV();
  });
}

private exportToCSV() {
  const fields = [
    'Team Member Code', 'Name', 'Email', 'Gender', 'Emplyement Type', 'Employee Status',
    'Designation', 'Work Location', 'Home Location', 'Lead', 'Lead IB Code',
    'Functional Lead', 'Functional Lead IB Code', 'Manager', 'Manager IB Code', 
    'Department', 'Business Unit', 'Delivery Unit',
    'Date Of Birth', 'Celebrated Date Of Birth', 'Marital Status', 'Mobile', 'Current Address',
    'Father Name', 'Mother Name', 'PAN', 'Date Of Joining',
    'Passport Number', 'Visa', 'Passport Expiry Date', 'Visa Expiry Date', 'Anniversary Date',
    'Name on Pan Card', 'Earlier Exit Remarks',
    'EmergencycontactNumber', 'AlternateEmailId', 'BloodGroup', 'Last Working Day',
    'Permanent Address', 'PF Number', 'UAN Number', 'ESIC', 'Adhar Number', 'Salary Account Number', 'Extension',
    'AboutYou', 'Contract Start Date', 'Contract End Date', 'Preffered Name', 'PFDOJ', 'ESICDOJ',
    'Graduate Specialization', 'Graduate Board Or University Name', 'Graduate School Or College Name', 'Graduate Passing Year', 'Graduate Percentage',
    'Post Graduate Specialization', 'Post Graduate Board Or University Name', 'Post Graduate School Or College Name', 'Post Graduate Passing Year', 'Post Graduate Percentage', 'Grade'
  ];

  if (this.teamMemberReportDump && this.teamMemberReportDump.length > 0) {
    new Angular2Csv(this.teamMemberReportDump, 'Team Member Report', { headers: fields });
  } else {
    this.msgs.push({ severity: 'warn', summary: 'Warning', detail: 'No data available to export.' });
  }
}
	//  generateReportForTeamMember() {
        
        
    //     var fields = ['Team Member Code', 'Name', 'Email', 'Gender', 'Emplyement Type','Employee Status',
    //                              'Designation', 'Work Location','Home Location','Lead', 'Lead IB Code',
    //                              'Functional Lead', 'Functional Lead IB Code', 'Manager','Manager IB Code', 'Department','Business Unit','Delivery Unit',
    //                             'Date Of Birth', 'Celebrated Date Of Birth', 'Marital Status', 'Mobile', 'Current Address',
    //                              'Father Name', 'Mother Name', 'PAN', 'Date Of Joining',
    //                              'Passport Number', 'Visa','Passport Expiry Date','Visa Expiry Date', 'Anniversary Date',
    //                               'Name on Pan Card', 'Earlier Exit Remarks',
    //                              'EmergencycontactNumber','AlternateEmailId','BloodGroup','Last Working Day',
    //                              'Permanent Address', 'PF Number', 'UAN Number', 'ESIC', 'Adhar Number', 'Salary Account Number', 'Extension',
    //                              'AboutYou', 'Contract Start Date', 'Contract End Date', 'Preffered Name', 'PFDOJ', 'ESICDOJ',
    //                              'Graduate Specialization', 'Graduate Board Or University Name','Graduate School Or College Name','Graduate Passing Year','Graduate Percentage',
    //                              'Post Graduate Specialization','Post Graduate Board Or University Name','Post Graduate School Or College Name','Post Graduate Passing Year','Post Graduate Percentage','Grade' ];

    //    var options = {
    //         quoteStrings: '""',
    //         decimalseparator:'.',
    //         showLabels: false,
    //         showTitle: false,
    //         title: '',
    //         useBom: true,
    //         headers: fields
    //     };

    //    if(this.teamMemberReportDump != undefined)
    //    {
    //     new Angular2Csv( this.teamMemberReportDump , 'Team Member Report', {headers: (fields)});
    //    }
    // }
}



export class PrimeProfile implements Profile {
	constructor(public id?: any,
		public teamMemberID?: any, public firstName?: any, public lastName?: any
		, public gender?: any
		, public email?: any
		, public dateOfBirth?: any
		, public mobile?: any
		, public pan?: any
		, public workLocation?: any
		, public fatherName?: any
		, public motherName?: any
		, public currentAddress?: any
		, public maritalStatus?: any
		, public emergencyContactNumber?: any
        ,public bloodGroup?: any
		, public designation?: any
		, public dateofJoining?: any
		, public businessUnit?: any
		, public employmentType?: any
        , public hiringType?: any
		, public systemRole?: any
		, public active?: any
		, public teamMemberCode?: any
		, public status?: any
		, public remarks?: any
		, public oldTeamMemberCode?: any
		, public manager?: any
		, public deliveryUnit?: any
		, public lead?: any
		, public functionalLead?: any
		, public isLoggedIn?: any
		, public alternateEmailId?: any
		, public punchCardSerial?: any
		, public locker?: any
		, public nameInPanCard?: any
		, public earlierExitRemarks?: any
		, public contractStartDate?: any
		, public contractEndDate?: any
		, public pfdoj?: any
		, public esicdoj?: any
		, public lastWorkingDay?: any
        , public departmentID?: any

        , public newDepartmentID?: any
        , public clientID?: any
        , public projectGroup?: any
        , public expertiseID?: any
        , public tempExpertiseID?: any
        , public primaryTechnology? : any
        , public secondaryTechnology?: any
        , public tertiaryTechnology?: any
        , public practiceID?: any
        , public gradeID?: any


        , public celebratedDateOfBirth?: any
		, public anniversaryDate?: any
        ,public practiceQualification?: any
        ,public delieveryQualification?: any
        ,public annualCTC?: any
        ,public ctcGroup?: any
        ,public variable?:any
        ,public relocationExpenses?: any
        ,public relocationExpensesPaymentDueDate?: any
        ,public recruiterName?: any
        ,public referralName?:any
        ,public joiningBonus?:any
        ,public joiningBonusPaymentDueDate?: any
        ,public noticePeriodBuyout?: any
        ,public noticePeriodBuyoutPaymentDueDate?: any
        ,public annualBonus?: any
        ,public annualBonusPaymentDueDate?: any
        ,public accomodationFromDate?: any
        ,public accomodationToDate?: any
        ,public accomodationLocation?: any
        ,public retentionBonus?: any
        ,public retentionBonusPaymentDueDate?:any
        ,public otherBonus?:any
        ,public otherBonusPaymentDueDate?: any
        ,public mNote?: any
        ,public anyContractDetails?:any
        ,public contractType?:any
        ,public contractDescription?:any
        ,public lWDPhysicalPerspective?: any
        ,public lWDPayrollPerspective?: any
        ,public reasonForLeaving?:any
        ,public referenceCheckFeedback?:any
        ,public noticePeriodInstructions?: any
        // ,public noticePeriodInstructions?:any
        ,public noticePeriodApproverName?: any
        ,public pFPreferenceAttheTimeOfExit?:any
        ,public nextOrganziationJoining?:any
        ,public designationInNextOrganization?: any
        ,public cTCInTheNextOrganization?: any
        ,public locationOfTheNextOrganizaion?:any
        ,public tenureWithInfobeans?:any
        ,public noticePeriodDuration?: any
        ,public backgroundVerificationInformation?: any
        ,public experienceBeforeInfoBeans?:any
        ,public previousLocation?: any
        ,public previousDesgination?: any
        ,public previousAnnualCTC?:any
        ,public l1RecruitmentFeedback?:string
        ,public l1PanelName?:string
        ,public l2RecruitmentFeedback?:string
        ,public l2PanelName?:string
        ,public hRFeedback?:string
        ,public hRPanelName?:string
        ,public lWDInPreviousOrganization?:string
        ,public homeLocation?: any

		, public workPlanStartDate?: any
		, public workPlanEndDate?: any
        ,public isTravelDetail?:any
        ,public travelType?: any
        ,public purpose?: any
        ,public isAgreement?: any
        ,public travelStartDate?: any
        ,public travelEndDate?: any
        ,public travelCountryVisited?: any
        ,public travelCityVisited?: any
        ,public travelClientVisited?: any
        ,public travelAgreementduration?: any
        ,public AgreementStartDate?: any
        ,public AgreementEndDate?: any
        ,public chequeNo?: any
        ,public chequeAmount?: any
        ,public uploadURLlink?: any
        ,public countryVisitedName?: any

        ,public isBGDetail?: any
        ,public bgVerificationStatus?: any
        ,public bgStatusCode?: any
        ,public verificationDoneBy?: any
        ,public verificationCompletedOn?: any
        ,public bgvCaseNo?: any
        ,public bgReportURL?: any

        //,public iscontractDetail?:any
        ,public contractPurpose?: any
        ,public contractAmount?: any
        ,public contractCheque?: any
     //   ,public contractType?: any
        ,public contractNote?: any
        ,public hrBusinessPartnerSelectedID?: any
        ,public companyID?: any
        ,public resignationDate? :string
        ,public payrollLWD? : string
        ,public confirmationDate? : string
        ,public noticePeriodId? : number
        ,public probationPeriodId? : number
        ,public initialDOJ? : string
        ,public priorRelevantExperience? : any

    ) { }
}

class PrimeLOV implements LOV {
	constructor(public id?: any, public lovTypeID?: any, public name?: any, public isDelete?: any) { }
}




// WEBPACK FOOTER //
// ./src/app/Components/TeamMemberManagement/TeamMember.ts